<template>
  <div class="error-page">
    <!-- Main Wrapper -->
    <div class="main-wrapper">
      <div class="container">
        <div class="error-box">
          <div class="error-img">
            <img
              src="@/assets/img/authentication/maintenance-img.png"
              class="img-fluid"
              alt=""
            />
          </div>
          <div class="error-content">
            <h3>We are Under Maintenance</h3>
            <p>
              Sorry for any inconvenience caused, we have almost done Will get back soon!
            </p>
            <router-link to="/dashboard/deals-dashboard" class="btn btn-primary">
              <i class="ti ti-arrow-narrow-left"></i> Back to Dashboard
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
